var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as Styled from './styled';
import { BrandConfiguration } from 'toca-config';
import { Auth } from '@aws-amplify/auth';
import PageErrorMessage from '../PageErrorMessage/PageErrorMessage';
import Link from '../Links/Link/Link';
var brand = BrandConfiguration.GetBrandConfiguration();
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.renderMessage = function () {
            return (React.createElement(React.Fragment, null,
                React.createElement(PageErrorMessage, null),
                React.createElement(Styled.LinkContainer, null,
                    React.createElement(Link, { underline: true, to: BrandConfiguration.getUserPortalUrl() }, "Back to Home"))));
        };
        _this.state = { hasError: false, isLoggedIn: false };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function () {
        this.setState({
            hasError: true,
        });
    };
    ErrorBoundary.prototype.componentDidMount = function () {
        var _this = this;
        Auth.currentAuthenticatedUser().then(function () {
            _this.setState({
                isLoggedIn: true,
            });
        });
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Styled.ToolbarContainer, null,
                    React.createElement(Styled.LogoConatiner, null,
                        React.createElement(Styled.Logo, { src: brand.brandConfiguration.logoUrlHeader }))),
                React.createElement(Styled.CenterContainer, null,
                    React.createElement(Styled.Wrapper, null, this.renderMessage()))));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
export default ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map